<template>
  <div v-if="visibleBanner" class="ld-leadsplus-retirement-banner">
    <v-layout
      justify-center
      align-center
      :style="{ 'background-color': color.background }"
    >
      <div class="banner-content">
        <v-icon small class="mr-1" :color="color.foreground">info</v-icon>
        <span :style="{ color: color.foreground }" v-html="bannerText"></span>
      </div>
      <v-btn small flat :color="color.foreground" @click="handleUpgradeNow">Explore Relationships →</v-btn>
      <v-btn
        id="lw-checkout-banner-hide"
        icon
        small
        @click="handleHide"
      >
        <v-icon class="white-icon">close</v-icon>
      </v-btn>
    </v-layout>
  </div>
</template>
  
<script>
import { createNamespacedHelpers, mapGetters } from 'vuex';
import { HC_PROPS } from 'lion-vue-src/_globals';
import { startOfDay, addDays } from 'date-fns';

const { mapState: mapAppLayoutState, mapActions: mapAppLayoutActions } = createNamespacedHelpers(
'ldAppLayout',
);

export default {
  props: {
    user: {
    type: Object,
    default: null,
    },
  },
  data() {
    return {
      color: {
        foreground: '#1E3B8A',
        background: '#F0F6FF',
      },
      isHiddenCookie: null,
      clientsPoller: null,
      creatingRelationshipsLicense: false,
      bannerText: `<strong>Heads up: LionDesk is being retired from Leads+.</strong> As part of <a href='https://www.lwolf.com/resources/upcoming-changes-to-your-leads-subscription' target='_blank'>changes to Leads+</a>, LionDesk will no longer be available as part of Leads+ after <strong>August 31st</strong>. Looking for a CRM? 
      You can purchase <strong>Lone Wolf Relationships</strong> separately to continue managing your contacts and communications.`,
    }
  },
  computed: {
    ...mapAppLayoutState([
      'isMigrationComplete',
      'isMigrationInProgress',
      'relationshipsLicenseCreatedFound',
      'ulToken',
      'ulClientLicenses',
      'hasRelationshipsOrder',
      'createRelationshipsLicenseSuccess',
    ]),
    visibleBanner() {
      if (!this.user) {
        return false;
      }

      console.log('this.relationshipsLicenseCreatedFound', this.relationshipsLicenseCreatedFound);
      if (this.relationshipsLicenseCreatedFound) {
        return false;
      }

      if (this.isHiddenCookie) {
        const displayDate = startOfDay(addDays(new Date(this.isHiddenCookie), 1));
        if (new Date() < displayDate) {
          return false;
        }
        window.$cookies.remove('hideLeadsPlusRetirementBanner', null, HC_PROPS.MAIN_DOMAIN);
        this.isHiddenCookie = false;
      }

      console.log('this.user.subscriptionOverview', this.user.subscriptionOverview);
      if (this.user.subscriptionOverview && this.user.subscriptionOverview.txt_plan === 'leads_plus') {
        return true;
      }

      if (this.user.subscriptionOverview && Array.isArray(this.user.subscriptionOverview.active_items)) {
        if (this.user.subscriptionOverview.active_items.some(item => item.toLowerCase().includes("leadsplus"))) {
          return true;
        };
      }
    
      return false
    },
  },
  async mounted() {
    this.isHiddenCookie = window.$cookies.get('hideLeadsPlusRetirementBanner');
    await this.checkMigrationStatus();
    await this.findRelationshipsLicenseCreated();
    await this.getUserULClients();
    await this.checkRelationshipsOrder();
  },
  methods: {
    ...mapAppLayoutActions([
      'findRelationshipsLicenseCreated',
      'checkMigrationStatus',
      'checkMigrationInProgress',
      'getUserULClients',
      'checkRelationshipsOrder',
      'createRelationshipLicense',
      'startMigration',
    ]),
    async handleUpgradeNow() {
      // no lwa_id = redirect to connect page
      if (!this.user.lwa_id) {
        window.location.href = `${HC_PROPS.ACCOUNTS_APP_URL}/connect-lone-wolf-account?state=connect&relationships=true`;
        return;
      }
      // lwa_id but no Relationships license = create Relationships license and migration then redirect to app
      if (this.user.lwa_id && !this.ulClientLicenses.includes('Relationships')) {
        this.creatingRelationshipsLicense = true;
        await this.checkMigrationStatus();
        await this.checkMigrationInProgress();
        if (!this.isMigrationComplete) {
          this.isMigratingContacts = true;
          if (!this.isMigrationInProgress) {
            this.startMigration({ userID: this.user.id });
          }
        }
        await this.createRelationshipLicense();
        if (this.createRelationshipsLicenseSuccess) {
          this.clientsPoller = setInterval(() => {
            this.getUserULClients();
          }, 1000);
        }
        return;
      }
      // lwa and relationships license = redirect to checkout page
      const userToken = this.$cookies.get('lwaToken') || this.ulToken;
      window.location.href = `${HC_PROPS.RELATIONSHIPS_URL}/contacts?checkout&jwt=${userToken}`;
    },
    handleHide() {
      window.$cookies.set('hideLeadsPlusRetirementBanner', new Date(), null, null, HC_PROPS.MAIN_DOMAIN);
      this.isHiddenCookie = window.$cookies.get('hideLeadsPlusRetirementBanner');
      this.$emit('show', false);
    }
  },
  watch: {
    visibleBanner(val) {
      console.log('visibleBanner watcher triggered:', val);
      if (val) this.$emit('show', val);
    },
    ulClientLicenses: {
      handler(newValue) {
        if (newValue && newValue.includes('Relationships') && this.clientsPoller) {
          clearInterval(this.clientsPoller);
          this.clientsPoller = null;
          setTimeout(() => {
            this.creatingRelationshipsLicense = false;
            window.location = `${HC_PROPS.UL_PLATFORM_URL}/product/launch?a=crm`
          }, 3000);
        }
      },
    },
  },
}
</script>

<style lang="scss" scoped>
.ld-leadsplus-retirement-banner {
  line-height: 1.4;
  height: 56px;
  width: 100%;
  
  .layout {
    margin: 0 24px;
    height: 100%;
  }
  
  .banner-content {
    display: flex;
    align-items: center;
    padding: 0 16px;
    max-width: 1315px;
    
    span {
      padding-left: 4px;
      ::v-deep a {
        color: #1E3B8A;
        text-decoration: underline !important;

        &:hover {
          text-decoration: underline !important;
        }
      }
    }
  }
  
  .v-btn.v-btn--icon.v-btn--small {
    margin-left: 12px;
  }
}
</style>